import { Component } from 'react'
import PropTypes from 'prop-types'

export default class IsolatedValue extends Component {
  static propTypes = {
    children: PropTypes.func,
    initialValue: PropTypes.any
  }

  constructor(props) {
    super()

    const { initialValue } = props || {}

    this.state = {
      value: initialValue === undefined ? null : initialValue
    }
  }

  setValue = value => {
    this.setState({ value })
  }

  render() {
    const { children } = this.props
    const { value } = this.state
    return children({ value, setValue: this.setValue })
  }
}
